export const setCurrentSurvey = (survey) => ({
  type: "SET_CURRENT_SURVEY",
  payload: { survey },
});

export const addAnswer = (answer) => ({
  type: "ADD_ANSWER",
  payload: { answer },
});

export const clearState = () => ({
  type: "CLEAR_STATE",
});
